<div #auftragsListeDatagridWrapper id="auftragsListeDatagridWrapper" class="clr-row nxm h-100">
  <div
    class="h-100"
    #datagridwrapper
    style="position: relative"
    [ngStyle]="{
      width:
        !showdetailview || hidedetailview ? '100%'
        : split50 ? '50%'
        : '66.66%',
      'z-index': 'auto',
    }">
    <ng-template #newAuftrag>
      @if (authService.token.rights.status > 2 && allowCreate && this.authService.getRight('view', 'AllowVAuftr')) {
        <button class="btn btn-sm margin-10-l" (click)="isNewAuftragModalOpen.set(true)">
          {{ 'Auftrag erstellen' | mrTranslate }}
        </button>
      }
      @if (isNewAuftragModalOpen()) {
        <app-newauftragmodal [(isModalOpen)]="isNewAuftragModalOpen" (reload)="reloadTabs()" />
      }
    </ng-template>
    @if (auftraege()?.rows.length; as auftrLength) {
      <div id="auftrDgWrapper" class="h-100" [dymanicStyle]="heightRef" maxSize="100%" (resized)="scroll()">
        <div class="clr-row">
          <ng-container *ngTemplateOutlet="newAuftrag" />
          @if (auftrLength != filterStore.filteredRows().length) {
            <button class="btn btn-primary btn-sm" (click)="filterStore.deleteAllFilters()">
              {{ 'Alle Filter zurücksetzen' | mrTranslate }}
            </button>
          }
        </div>
        <clr-datagrid
          #auftrDg
          [deselectButton]="true"
          class="datagrid-compact"
          [clrDgItemsIdentityFn]="row => row?.auftrag"
          [clrDgSelectionType]="'single'"
          [clrDgSelected]="[selectedAuftrag]"
          (clrDgSelectedChange)="selectedAuftrag = $event[0]">
          @for (column of auftraege().columns; track column.id) {
            <clr-dg-column
              [clrDgField]="column.id"
              [attr.id]="'datagrid-auftraege-col-' + (column.id | get: normalizedId)"
              [attr.data-test-id]="'datagrid-auftraege-col-' + column.id"
              [style.min-width.px]="
                column.id == 'status' ? 150
                : column.id == 'abnahmeStatus' ? 55
                : column.id.length * 7.5 + 45
              ">
              <clr-dg-filter [attr.data-test-id]="'datagrid-auftraege-col-filter-' + column.id">
                <app-column-filter
                  [column]="column"
                  [objektTypIconValue]="filterStore.iconMap()"
                  [uniqueColumnValues]="filterStore.uniqueValues()[column.id]"
                  (changes)="filterStore.onChange($event)" />
              </clr-dg-filter>

              <ng-template
                [clrDgHideableColumn]="{ hidden: column.id | hideIDColumns: hides }"
                (clrDgHiddenChange)="columnHiddenChange(columns)">
                @if (column.id == 'abnahmeStatus') {
                  <cds-icon style="flex: 0 0 auto" size="20" shape="certificate" [title]="'Abnahme' | mrTranslate" />
                } @else {
                  <span>{{ column.id | titlecase | mrTranslate }}</span>
                }
              </ng-template>
            </clr-dg-column>
          }
          <ng-template
            clrVirtualScroll
            let-row
            [clrVirtualRowsOf]="filterStore.filteredRows()"
            [clrVirtualRowsTrackBy]="(_, row) => row?.auftrag">
            <clr-dg-row [clrDgItem]="row" id="a-{{ row.auftrag }}">
              <clr-dg-action-overflow>
                @if (authService?.token?.rights?.status > 1) {
                  <button class="action-item" (click)="openAuftrag(row)">
                    {{ 'Auftrag öffnen' | mrTranslate }}
                  </button>
                }
                <button class="action-item" (click)="openPDF(row)">
                  {{ 'PDF öffnen' | mrTranslate }}
                </button>
              </clr-dg-action-overflow>
              @for (cell of auftraege().columns; track cell.id) {               
				        @switch (cell.id) {
                  @case ('abnahmeStatus') {
                    <clr-dg-cell [title]="'Abnahme' | mrTranslate" [style.min-width.px]="55">
                      @if (row['abnahmeStatus']) {
                        <clr-dropdown>
                          <button type="button" clrDropdownTrigger aria-label="toggle abnahmen protokolls">
                            <cds-icon class="activecolor" size="20" shape="certificate" />
                          </button>
                          <ng-template [clrIfOpen]="false" (clrIfOpenChange)="abnahmeDropdownID.set(row.auftrag)">
                            <clr-dropdown-menu clrPosition="bottom-left">
                              @if (abnahmeLoading()) {
                                <clr-spinner class="centred" [clrMedium]="true" />
                              } @else {
                                @for (file of abnahmen(); track file.AbnahmeId) {
                                  <a (click)="openAbnahmePDF(file.AbnahmeId)" clrDropdownItem>{{ file.Date }}</a>
                                } @empty {
                                  <span class="margin-10-lr">{{ 'keine Daten vorhanden' | mrTranslate }}</span>
                                }
                              }
                            </clr-dropdown-menu>
                          </ng-template>
                        </clr-dropdown>
                      }
                    </clr-dg-cell>
                  }
                  @case ('erlstatus') {
                    @switch (row[cell.id]) {
                      @case (0) {
                        <clr-dg-cell class="name-cell" [title]="'Nicht abgeschlossen' | mrTranslate "><span class="erlstatus-symbol">&#x2610;</span></clr-dg-cell>
                      }
                      @case (1) {
                        <clr-dg-cell class="name-cell" [title]="'Abgeschlossen' | mrTranslate "><span class="erlstatus-symbol">&#x2611;</span></clr-dg-cell>
                      }
                      @case (2) {
                        <clr-dg-cell class="name-cell" [title]="'Teilweise abgeschlossen' | mrTranslate "><span class="erlstatus-symbol intermediate">&#x229F;</span></clr-dg-cell>
                      }
                    }
                  }
                  @default {
                    <clr-dg-cell><app-icon-dg-cell [row]="row" [column]="cell" /></clr-dg-cell>
                  }
                }                
              }
            </clr-dg-row>
          </ng-template>

          <clr-dg-footer>
            <div class="footerbox">
              <div>
                <button class="minibutton" [title]="'Spaltenfilter löschen' | mrTranslate" (click)="removeColFilter()">
                  <cds-icon shape="filter-off"></cds-icon>
                </button>
              </div>
              <div class="dbNameTable">{{ formatDBName }}</div>
              <div>{{ filterStore.filteredRows().length }} {{ 'Zeilen' | mrTranslate }}</div>
            </div>
          </clr-dg-footer>
        </clr-datagrid>
      </div>
    } @else {
      <div class="h-100 d-f col clr-align-items-center clr-justify-content-center">
        <ng-container *ngTemplateOutlet="newAuftrag" />
      </div>
    }
    <div #heightRef id="blockObjMng" class="main-background">
      @if (objTable?.rows?.length; as objLength) {
        <div class="h-100">
          <div #heightRefObj class="dgsWrapper objektTable" style="--obj-rows-count: {{ objLength }}">
            <div>
              <h4 class="tableHeadline">{{ 'Objekte' | mrTranslate }}</h4>
            </div>
            <clr-datagrid
              #objDg
              [clrDgSelectionType]="'multi'"
              [(clrDgSelected)]="selectedObjects"
              [clrDgCustomSelectAllEnabled]="true"
              (clrDgCustomSelectAll)="selectedObjects = $event ? objTable.rows : []"
              [clrDgItemsIdentityFn]="row => row?.ostammid"
              class="datagrid-compact">
              @for (column of objTable.columns; track column.id) {
                <clr-dg-column
                  [style.min-width.px]="column.id == 'status' ? 150 : column.id.length * 7.5 + 45"
                  [clrDgField]="column.id">
                  <ng-template
                    [clrDgHideableColumn]="{ hidden: column.id | hideIDColumns: hidesobj }"
                    (clrDgHiddenChange)="columnHiddenChangeObj()">
                    {{ column.id | titlecase | mrTranslate }}
                  </ng-template>
                </clr-dg-column>
              }

              <ng-template
                clrVirtualScroll
                let-row
                [clrVirtualRowsOf]="objTable.rows"
                [clrVirtualRowsTrackBy]="(_, row) => row?.ostammid">
                <clr-dg-row [clrDgItem]="row">
                  <clr-dg-action-overflow>
                    <button class="action-item" (click)="ostammid = row.ostammid">
                      {{ 'Objekt öffnen' | mrTranslate }}
                    </button>
                  </clr-dg-action-overflow>
                  @for (cell of objTable.columns; track cell.id) {
                    @if (cell.id != 'typ') {
                      <clr-dg-cell><app-icon-dg-cell [row]="row" [column]="cell" /></clr-dg-cell>
                    } @else {
                      <clr-dg-cell>
                        <cds-icon class="grid-icon fill-black" [shape]="'objekttyp' + row['typ']" size="28"></cds-icon>
                      </clr-dg-cell>
                    }
                  }
                </clr-dg-row>
              </ng-template>
              <clr-dg-footer>
                <div class="footerbox">
                  <div>
                    <button
                      class="minibutton"
                      [title]="'Spaltenfilter löschen' | mrTranslate"
                      (click)="removeColFilterObj()">
                      <cds-icon shape="filter-off"></cds-icon>
                    </button>
                  </div>
                  <div>{{ objTable.rows.length }} {{ 'Zeilen' | mrTranslate }}</div>
                </div>
              </clr-dg-footer>
            </clr-datagrid>
          </div>
          <div class="dgsWrapper mangelTable" style="--mngl-rows-count: {{ mnglTable.rows.length }}">
            <h4 class="tableHeadlineMangel">
              {{ 'Mängel' | mrTranslate }}
            </h4>
            <clr-datagrid
              #mnglDg
              class="datagrid-compact phSmall"
              [clrDgItemsIdentityFn]="row => row?.omazsid"
              [dymanicStyle]="heightRefObj"
              styleMode="max-height"
              addPx="310"
              diminutiv="100svh"
              maxSize="50vh">
              <clr-dg-column [style.min-width.px]="72">{{ 'GIS Map' | mrTranslate }}</clr-dg-column>
              <clr-dg-column [style.min-width.px]="55">{{ 'Medien' | mrTranslate }}</clr-dg-column>
              @for (column of mnglTable.columns; track column.id) {
                <clr-dg-column
                  [style.min-width.px]="column.id == 'status' ? 150 : column.id.length * 7.5 + 45"
                  [clrDgField]="column.id">
                  <ng-template
                    [clrDgHideableColumn]="{ hidden: column.id | hideIDColumns: hidesmang }"
                    (clrDgHiddenChange)="columnHiddenChangeMang()">
                    {{ column.id | titlecase | mrTranslate }}
                  </ng-template>
                </clr-dg-column>
              }

              <ng-template
                clrVirtualScroll
                let-row
                [clrVirtualRowsOf]="mnglTable.rows"
                [clrVirtualRowsTrackBy]="(_, row) => row?.omazsid">
                <clr-dg-row [clrDgItem]="row">
                  <clr-dg-cell [style.min-width.px]="72">
                    @let objekt = row | get: getObjektByMangel;
                    @if (objekt | get: getGeometryType) {
                      <clr-tooltip>
                        <a href="javascript:void(0)" (click)="previewMap(row, objekt)">
                          <cds-icon size="20" shape="search" />
                        </a>
                      </clr-tooltip>
                    } @else {
                      <cds-icon size="20" shape="search" disabled></cds-icon>
                    }
                  </clr-dg-cell>
                  <clr-dg-cell [style.min-width.px]="55">
                    <a
                      href="javascript:void(0);"
                      (click)="mangelMedia = media.parseMediaPath(row.Bild, row.rueckbilder)"
                      [class.deactivate]="!row.Bild && !row.rueckbilder">
                      <cds-icon
                        [shape]="!row.Bild && !row.rueckbilder ? 'blank' : 'image-gallery'"
                        size="20"></cds-icon>
                    </a>
                  </clr-dg-cell>
                  @for (cell of mnglTable.columns; track cell.id) {
                    <clr-dg-cell><app-icon-dg-cell [row]="row" [column]="cell" /></clr-dg-cell>
                  }
                </clr-dg-row>
              </ng-template>

              <clr-dg-footer>
                <div class="footerbox">
                  <div>
                    <button
                      class="minibutton"
                      [title]="'Spaltenfilter löschen' | mrTranslate"
                      (click)="removeColFilterMang()">
                      <cds-icon shape="filter-off"></cds-icon>
                    </button>
                  </div>
                  <div>{{ mnglTable.rows.length }} {{ 'Zeilen' | mrTranslate }}</div>
                </div>
              </clr-dg-footer>
            </clr-datagrid>
          </div>
        </div>
      }
    </div>
  </div>

  @if (showdetailview) {
    <div #dvwrapdper id="wrapperdetailview" [ngClass]="{ sidenavenlarged, split50, hidedetailview }">
      <app-detailview
        [ostammid]="ostammid"
        [progressbarenlarged]="progressbarenlarged"
        [expanded]="sidenavenlarged"
        [hidden]="hidedetailview"
        [split50]="split50"
        (enlarge)="enlargeSidenav($event)"
        (enlargePB)="enlargeProgressbar(true)"
        (progressData)="showProgressData($event)"
        (indexScrub)="handleScrub($event)"
        (reload)="loadAuftraege()"
        #detailView></app-detailview>
    </div>
  }

  @if (showprogressbar) {
    <div id="progresstrigger" [class.bottom]="!progressbarenlarged">
      <div class="wrap" (click)="enlargeProgressbar()">
        <cds-icon
          shape="angle"
          [direction]="progressbarenlarged ? 'down' : 'up'"
          class="expandProgressbarButton cursor-pointer" />
      </div>
    </div>
    @if (progressbarenlarged) {
      <footer id="wrapperprogressbars" class="clr-row nxm clr-align-items-center">
        <app-progressbar
          [dataIn]="progressbars"
          [indexScrub]="indexScrub"
          (enlargeProgressbar)="enlargeProgressbar(true)"
          style="display: inline-block; width: calc(100% - 35px)" />
      </footer>
    }
  }
</div>

<clr-modal [(clrModalOpen)]="showGIS" [clrModalSize]="'lg'">
  <h3 class="modal-title">{{ 'GIS Map' | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm>
      <div style="width: 854px; height: 580px">
        <div id="previewMap" style="width: 100%; height: 100%; z-index: 2"></div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="showGIS = false">
      {{ 'Schließen' | mrTranslate }}
    </button>
  </div>
</clr-modal>

@if (mangelMedia) {
  <app-mediaviewmodal
    (onClose)="mangelMedia = undefined"
    [srcs]="mangelMedia"
    [getMediaFromServerAll]="media.getApiFunctionMedia"
    [getBigFileFnc]="media.getApiFunctionMediaBig"
    (openPdfOverlay)="openPdfMangel($event)" />
}
